import { combineReducers } from 'redux';
import featureReducers from './features/featuresReducer';

const rootReducer = combineReducers(featureReducers);

export default rootReducer;

export type GlobalState = ReturnType<typeof rootReducer>;
